export const environment = {
    version: '1.0.0',
    production: true,
    url: 'https://silgov.com.br',
    urlLogin: 'https://app.silgov.com.br',
    urlApi: 'https://portal-bff-prd.silgov.io',
    url_authentication_api: 'https://auth-prd.silgov.io',
    runtimeConfigUrl: '/runtime-config.json',
    // Cadastro de cidadão (visitante, spec 048 do app-frontend): desligado até o fim do deploy de todos os repositórios.
    visitorSignupEnabled: true
}
